import React, { useEffect } from 'react'
import './style.sass'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { clearAuthData } from '../../../../redux/actions/auth'
import LoadingBlock from '../../../common/LoadingBlock'
import { persistor } from '../../../../App'
import AuthService from '../../../../services/AuthService'

const LogoutCallback = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(async () => {
    const user = await AuthService.instance.getUser()
    if (user && !user.expired) {
      await AuthService.instance.logoutRedirect()
    } 
    clearAllData()
    history.push('/')
  }, [])

  const clearAllData = () => {
    dispatch(clearAuthData())
    localStorage.clear()
    persistor.purge()
  }

  return (
    <div className="logout-callback-component-container">
      <LoadingBlock message="Logging out, please wait..." />
    </div>
  )
}

export default LogoutCallback